import { mdiViewGridPlusOutline } from '@mdi/js'

export default {
  title: 'Majors',
  to: 'majors',
  icon: mdiViewGridPlusOutline,
  resource: 'MajorsAdmin',
  action: 'read',
}
